import { createFileRoute, Link, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/admin')({
  component: AdminLayout,
})

const TABS = [
  { to: '/admin/cargas', label: 'Anexos' },
  { to: '/admin/dias-servicio', label: 'Días de servicio' },
  { to: '/admin/zonas', label: 'Zonas' },
  { to: '/admin/serie', label: 'Serie de ping' },
] as const

function AdminLayout() {
  return (
    <div className="bg-slate-100 min-h-screen">
      <div className="px-6 pt-6 pb-0">
        <h1 className="text-2xl font-bold">Administración</h1>
        <p className="text-sm text-gray-500">
          Carga y mantenimiento de los datos del proyecto. Cada carga se previsualiza antes de escribir.
        </p>

        <nav className="flex gap-1 mt-5 border-b">
          {TABS.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              className="px-4 py-2 text-sm rounded-t-md border border-b-0 border-transparent text-muted-foreground hover:text-foreground transition-colors [&.active]:bg-white [&.active]:border-border [&.active]:text-foreground [&.active]:font-semibold"
            >
              {t.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="p-6">
        <Outlet />
      </div>
    </div>
  )
}
